import { useMemo } from "react";

import { IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import type { FeedbackReaction } from "app/pages/sales-intelligence/modules/ai-agent/types/thread";

import { StyledFeedbackIconWrapper } from "./styles";

type FeedbackButtonProps = {
    reaction: FeedbackReaction;
    isActive: boolean;
    onFeedback: (reaction: FeedbackReaction) => void;
    isDisabled?: boolean;
    dataAutomation?: string;
};

const FeedbackButton = ({ reaction, onFeedback, isActive, isDisabled, dataAutomation }: FeedbackButtonProps) => {
    const iconName = useMemo(() => {
        if (reaction === "like") {
            return isActive ? "thumb-up" : "thumb-up-outline";
        }

        return isActive ? "thumb-down" : "thumb-down-outline";
    }, [isActive, reaction]);

    return (
        <Tooltip
            content={translate(`si.pages.ai_agent.${reaction}`)}
            enabled={!isDisabled}
        >
            <StyledFeedbackIconWrapper flip={!!(isActive && reaction === "dislike")}>
                <IconButton
                    onClick={onFeedback}
                    iconName={iconName}
                    iconSize="xs"
                    type="flat"
                    isDisabled={isDisabled}
                    data-automation={dataAutomation}
                />
            </StyledFeedbackIconWrapper>
        </Tooltip>
    );
};

export default FeedbackButton;
